// extracted by mini-css-extract-plugin
export default {"AnswerRow":"QuestionsReport_AnswerRow__SnZZO","Break":"QuestionsReport_Break__X54PL"};